import { OptionalCoverages, Package, Price } from 'src/app/api/models/price.model';
import { VyVContractCreateResponse } from 'src/app/api/models/vyVContractCreateResponse';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { Contract, Tarification, TypePromo } from 'src/app/core/models/form-state.model';
import { PrimesAssuranceScolaire } from './../../core/models/form-state.model';

export class ApiResponseBodyUtils {
  static ExtractTarifResponseBody(response: Price, path: string): Tarification {
    return {
      HasAnyPromotion: response.hasAnyPromotion,
      Promotion: {
        TypePromo: response.promotion?.promotionType.includes('Discount')
          ? ('Pourcentage' as TypePromo)
          : response.promotion?.promotionType === 'Month'
          ? ('MoisOfferts' as TypePromo)
          : undefined,
        DetailsPromo: response.promotion?.promotionLabel
      },
      Formules: response.packages.map(p => ({
        NomFormule: ApiResponseBodyUtils.getNomFormule(p.code),
        PrimeMensuelle: p.monthlyPremiumAmountIncludingTax,
        PrimeAnnuelle: p.annualPremiumAmountIncludingTax,
        PrimesOptions: {
          ObjetsValeur: p.optionalCoverages.OBJVAL
            ? {
                Valeur10000: p.optionalCoverages.OBJVAL['10K'],
                Valeur15000: p.optionalCoverages.OBJVAL['20K']
              }
            : undefined,
          ProtectionNomades: p.optionalCoverages.ANO ? p.optionalCoverages.ANO['_'] : undefined,
          ProtectionJuridique: ApiResponseBodyUtils.GetProtectionJuridiqueOption(p),
          ProtectionVelos: p.optionalCoverages.VELO ? p.optionalCoverages.VELO['_'] : undefined,
          AssuranceScolaire: this.ReturnAssuranceScolaire(path, p.optionalCoverages),
          ValeurANeuf: p.optionalCoverages.VAN ? p.optionalCoverages.VAN['_'] : undefined,
          Vol: p.optionalCoverages.VLX ? p.optionalCoverages.VLX['_'] : undefined
        }
      }))
    };
  }

  static GetProtectionJuridiqueOption(p: Package): number | undefined {
    return p.optionalCoverages.PJ?._ ?? p.optionalCoverages.PJSOL?._;
  }

  static getNomFormule(code: string | undefined): string {
    //  p.code == 'CON' ? 'F1' : p.code == 'CON+' ? 'F2' : p.code == 'PAR' ? 'LM' : 'LM',
    switch (code) {
      case 'CON':
        return 'F1';
      case 'CON+':
        return 'F2';
      case 'PAR2':
        return 'PAR2';
      case 'SOL2':
        return 'SOL2';
      case 'ETU':
        return 'ETU';
      case 'GRE':
        return 'GRE';
      case 'CRE':
        return 'CRE';
      case 'MAR':
        return 'MAR';
      case 'LIL2':
        return 'LIL2';
      case 'TOU2':
        return 'TOU2';
      case 'BSOL':
        return 'BSOL';
      default:
        return 'LM';
    }
  }

  static ExtractContractResponseBody(response: VyVContractCreateResponse): Contract {
    return {
      EstSansEffet: false,
      EstSigne: false,
      NumeroContrat: response.NumeroContrat,
      RefDocumentCP: response.RefDocumentCP,
      RefDocumentFIC: response.RefDocumentFIC,
      RefDocumentMandatSEPA: response.RefDocumentMandatSEPA,
      RefDocumentAttestation: response.RefDocumentAttestation,
      RefDocumentCG: response.RefDocumentCG,
      RefDocumentsSI: response.RefDocumentsSI,
      ClientAdvisorFullName: response.ClientAdvisorFullName,
      RefOtherDocuments: response.RefOtherDocuments ?? []
    };
  }

  static ReturnAssuranceScolaire(
    path: string,
    optionalCoverages: OptionalCoverages
  ): PrimesAssuranceScolaire | undefined {
    if (
      path == PathType.HOUSING ||
      path == PathType.HOUSING_SOLIDARITY ||
      path == PathType.HOUSING_BAILLEURS_SOCIAUX
    ) {
      return optionalCoverages.RCS
        ? {
            Enfant1: optionalCoverages.RCS['1'],
            Enfant2: optionalCoverages.RCS['2'],
            Enfant3: optionalCoverages.RCS['3'],
            Enfant4: optionalCoverages.RCS['4+'],
            Enfant5: optionalCoverages.RCS['4+'],
            Enfant6: optionalCoverages.RCS['4+']
          }
        : undefined;
    } else {
      return optionalCoverages.RCS
        ? {
            Enfant1: optionalCoverages.RCS['1'],
            Enfant2: optionalCoverages.RCS['2'],
            Enfant3: optionalCoverages.RCS['3'],
            Enfant4: optionalCoverages.RCS['4'],
            Enfant5: optionalCoverages.RCS['5'],
            Enfant6: optionalCoverages.RCS['6']
          }
        : undefined;
    }
  }
}
